import { Box, Button, Dialog, DialogContent, Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";

import { buttonBaseStyle, buttonSizeStyles, buttonToneStyles } from "@/buttonStyles";
import theme from "@/theme";

import BriberyIcon from "@assets/image/smaul_popup_bribery.png";
import CallIcon from "@assets/image/smaul_popup_call.png";
import ExpenseIcon from "@assets/image/smaul_popup_expense.png";
import SmaulPopupFvImage from "@assets/image/smaul_popup_fv.png";
import ListenerIcon from "@assets/image/smaul_popup_listener.png";

const useStyles = makeStyles(() => ({
  dialogPaper: {
    borderRadius: 8,
    overflow: "visible",
    backgroundColor: theme.palette.background.paper,
  },
  dialogContent: {
    padding: 0,
    position: "relative",
    overflow: "visible",
    "&.MuiDialogContent-root:first-child": {
      paddingTop: 0,
    },
  },
  contentShell: {
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: "#D2E7FF",
  },
  closeButton: {
    position: "absolute",
    top: 0,
    right: 0,
    transform: "translate(50%, -50%)",
    padding: 10,
    zIndex: 2,
    color: theme.palette.common.white,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.55)",
    },
  },
  heroImage: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  body: {
    padding: theme.spacing(2, 2.5, 2.5),
  },
  featureCard: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 16,
    padding: theme.spacing(1.5, 1),
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    boxSizing: "border-box",
  },
  featureIcon: {
    width: 32,
    height: 32,
    objectFit: "contain",
  },
  featureText: {
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.5,
    whiteSpace: "pre-line",
    marginTop: theme.spacing(1),
  },
  featureStrongBlueText: {
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
  featureStrongBlackText: {
    color: theme.palette.text.primary,
    fontWeight: 700,
  },
  note: {
    marginTop: theme.spacing(1),
    color: theme.palette.semantic["text/secondary"],
    fontSize: 10,
    fontWeight: 400,
    lineHeight: 1.5,
  },
  ctaButton: {
    marginTop: theme.spacing(1.5),
    width: "100%",
    "&&&": { ...buttonBaseStyle, ...buttonSizeStyles.L, ...buttonToneStyles.trust },
  },
}));

type Props = {
  open: boolean;
  onClose: () => void;
  onApply: () => void;
};

export const SmaulStartupModal: React.FC<Props> = ({ open, onClose, onApply }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ className: classes.dialogPaper }}>
      <DialogContent className={classes.dialogContent}>
        <IconButton className={classes.closeButton} onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>

        <Box className={classes.contentShell}>
          <img src={SmaulPopupFvImage} alt="SMAUL" className={classes.heroImage} />
          <Box className={classes.body}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Box className={classes.featureCard}>
                  <img src={ListenerIcon} alt="" className={classes.featureIcon} />
                  <Typography className={classes.featureText}>
                    投資ワンルーム専門の20社が
                    <span className={classes.featureStrongBlueText}>「最高値」</span>
                    <span className={classes.featureStrongBlackText}>を競い合います</span>
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className={classes.featureCard}>
                  <img src={BriberyIcon} alt="" className={classes.featureIcon} />
                  <Typography className={classes.featureText}>
                    業者との複雑な交渉や調整は
                    <span className={classes.featureStrongBlueText}>すべてコンシェルジュ</span>
                    <span className={classes.featureStrongBlackText}>がサポート</span>
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className={classes.featureCard}>
                  <img src={ExpenseIcon} alt="" className={classes.featureIcon} />
                  <Typography className={classes.featureText}>
                    仲介手数料は
                    <span className={classes.featureStrongBlueText}>かかりません</span>
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className={classes.featureCard}>
                  <img src={CallIcon} alt="" className={classes.featureIcon} />
                  <Typography className={classes.featureText}>
                    不動産会社からの営業電話は
                    <span className={classes.featureStrongBlueText}>一切ありません</span>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Typography className={classes.note}>
              ※弊社コンシェルジュが査定に必要な情報をまとめるため、一度だけお電話させていただきます。
            </Typography>
            <Button className={classes.ctaButton} onClick={onApply}>
              お申し込みはこちらから
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SmaulStartupModal;
